import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { OrderDTO, PaymentDTO, PaymentDTOTransactionTypeEnum, PaymentMethodPaymentMethodIdEnum } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';
import { FormService } from 'src/app/core/services/form.service';
import { Refund } from 'src/app/core/states/orders/orders.action';

@Component({
    selector: 'app-manual-refund',
    templateUrl: './manual-refund.component.html',
    styleUrls: ['./manual-refund.component.scss'],
    standalone: false
})
export class ManualRefundComponent {
  bankTransferForm?: FormGroup;
  loading = false;

  readonly onDestroy$ = new Subject<void>();

  constructor(
    readonly dialog: MatDialogRef<ManualRefundComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      order: OrderDTO;
      refund: PaymentDTO;
      maxRefund: number;
      orderItemId: number;
    },
    readonly store: Store,
    readonly formBuilder: FormBuilder,
    readonly formService: FormService
  ) {}

  ngOnInit(): void {
    /* Create form */
    this.bankTransferForm = this.formBuilder.group({
      refundAmount: new FormControl<number | undefined>(this.data.maxRefund, [
        Validators.required,
        Validators.max(this.data.maxRefund),
        Validators.min(1),
      ]),
      refundComment: new FormControl<string | undefined>(
        undefined,
        [Validators.required, this.formService.noWhitespaceValidator]
      ),
    });
  }

  refund() {
    if (this.bankTransferForm?.valid) {
      this.loading = true;
      const payment: PaymentDTO = {
        paymentMethod: { paymentMethodId: PaymentMethodPaymentMethodIdEnum.Bank },
        transactionType: PaymentDTOTransactionTypeEnum.Refund,
        amount: this.bankTransferForm.value.refundAmount,
        comment: this.bankTransferForm.value.refundComment,
      };
      this.store
        .dispatch(
          new Refund(
            this.data.order.orderId!,
            this.data.orderItemId,
            this.data.refund.paymentId!,
            payment
          )
        )
        .pipe(takeUntil(this.onDestroy$))
        .subscribe({
          next: () => {
            this.dialog.close({ success: true });
            this.loading = false;
          },
          error: (error) => {
            console.error('Error refunding order: ', error);
            this.loading = false;
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
